import 'babel-polyfill';
import Swiper from  'swiper/dist/js/swiper';
import axios from 'axios';
import initQtyInput from '../qtyInput';
import Popup from '../Popup';

import { mapState, mapActions } from 'vuex';
import store from '../store';
import i18n from '../vue_i18n';
//vue component
import WineSelect from '../vue_components/WineSelect';
import AddOnsSelect from '../vue_components/AddOnSelect';
import QtyInput from '../vue_components/QtyInput';


axios.defaults.headers.common['X-CSRF-TOKEN'] = $('meta[name="csrf-token"]').attr('content');


function initProductPhotos(productPhotosContainer) {

    const productPhotoList = new Swiper(productPhotosContainer.find('.product-photo-list'), {
        slidesPerView: 3,
        slidesPerGroup: 3,
    })

    const onSlideChange = function() {
        $('.product-photo-list img').removeClass('active');
        $(`.product-photo-list img[data-index=${this.realIndex}]`).addClass('active');
        productPhotoList.slideTo(this.realIndex);
    }

    const productPhotos =  new Swiper(productPhotosContainer.find('.product-photos'), {
        slidesPerView: 1,
        speed: 500,
        on: {
            init: onSlideChange,
            slideChange: onSlideChange,
            touchMove: (e) => e.stopPropagation()
        }
    });

    productPhotoList.$el.find('img').on('click', (e) => {
        productPhotos.slideTo($(e.target).attr('data-index'));
    });

    productPhotosContainer.find('.btn-prev').on('click', () => productPhotos.slidePrev());
    productPhotosContainer.find('.btn-next').on('click', () => productPhotos.slideNext());

}

function initTabs() {

    $('.tab').on('click', (e) => {
        const tab = $(e.target).closest('.tab');
        //remove active class from both tab and tab-content
        $('.tab').removeClass('active');
        $('.tab-content').removeClass('active');
        //add active class to the tab and tab-content
        tab.addClass('active');
        $(`#${tab.attr('data-target')}`).addClass('active');
    })

}

function initZoomInImage() {

    $('.product-photos .swiper-slide')
        .on('mouseenter', function(e) {
            this.style.backgroundSize = '600px 600px'
        })
        .on('mousemove', function(e) {
            const el = e.target;
            const posX = e.offsetX ? (e.offsetX) : e.pageX - el.offsetLeft;
            const posY = e.offsetY ? (e.offsetY) : e.pageY - el.offsetTop;
            el.style.backgroundPosition = (-posX) + "px " + (-posY) + "px";
        })
        .on('mouseout', function(e) {
            this.style.backgroundSize = '300px 300px';
            this.style.backgroundPosition = "center center";
        })
    ;
}

$(document).ready(function() {
    //product photos
    initProductPhotos($('#product-photos-container'));
    //qty input
    initQtyInput();
    //tabs
    initTabs();
    //product photo
    initZoomInImage();

    window.popups.productDetailsPopup = new Popup($('#product-details-popup'));

    window.popups.askExcelOrderPopup = new Popup($('#ask-excel-order-popup'));
    window.popups.askExcelOrderPopup.popup.find('button.btn-confirm').on('click', () => {
        sessionStorage.setItem('isShowAskExcelOrderPopup', true);
    })

});

window.productDetailsContainerVm = new Vue({
    components: {
        WineSelect,
        AddOnsSelect,
        QtyInput
    },
    el: '#product-details-container',
    store,
    i18n,
    data() {
        return {
            product_id: document.querySelector('input[name=product_id]').value,
            product: null,
            productWineGroups: [],
            wineGroups: [],
            addOns: [],
            selectedWines: [],
            selectedAddOns: [],
            qty: 1,
        }
    },
    computed: {
        ...mapState({
            isLoading: state => state.isLoading,
            sessionOrder: state => state.sessionOrder.sessionOrder,
        }),
        flattenAddOns() {
            return this.addOns.map(item => item.add_ons).reduce((acc, val) => acc.concat(val), []);
        },
        unitPrice() {
            return this.getUnitPrice();
        },
        productGrandTotal() {
            return this.unitPrice*this.qty;
        },
        productOriginalGrandTotal() {
            return this.getUnitPrice('original_price')*this.qty;
        }
    },
    methods: {
        ...mapActions({
            addOrderItem: 'sessionOrder/addOrderItem'
        }),
        getUnitPrice(type='price') {
            const productPrice =  Number.parseFloat(this.product[type]);
            const winePrice = this.selectedWines.reduce((sum, selectedWine) => {
                const wines = this.getWinesByProductWineGroupId(selectedWine.product_wine_group_id);
                const wine = wines.find(item => item.id === selectedWine.wine_id);
                return sum + Number.parseFloat(wine && wine.price !== null ? wine.price : 0);
            }, 0);
            const addOnPrice = this.selectedAddOns.reduce((sum, selectedAddOn) => {
                const addOn = this.getAddOn(selectedAddOn.add_on_id);
                const addOnPrice = Number.parseFloat(addOn ? addOn.price : 0)*selectedAddOn.qty
                return sum + addOnPrice;
            }, 0);
            return productPrice + winePrice + addOnPrice;
        },
        getAddOn(addOnId) {
            const addOn = this.flattenAddOns.find(item => item.id === addOnId);
            return addOn === undefined ? null : addOn;
        },
        /**
         * Get wines by product_wine_group_id
         * @param productWineGroupId
         * @returns {Array}
         */
        getWinesByProductWineGroupId(productWineGroupId) {
            const productWineGroup = this.$data.productWineGroups.find(item => item.id === productWineGroupId);
            if(productWineGroup === undefined) return [];

            const wineGroupId = productWineGroup.wine_group_id;
            const wineGroup = this.$data.wineGroups.find(item => item.id === wineGroupId);

            return wineGroup !== undefined ? wineGroup.wines : [];
        },
        /**
         * Update selectedWine in data
         * @param productWineGroupId
         * @param wineId
         */
        updateSelectedWineId(productWineGroupId, wineId) {
            const index = this.$data.selectedWines.findIndex(item => item.product_wine_group_id === productWineGroupId);
            if(index === -1) return;
            this.$data.selectedWines[index].wine_id = wineId;
        },
        /**
         * Update add on qty in SelectedAddOns
         * @param addOnId
         * @param qty
         */
        updateSelectedAddOnQty(addOnId, qty) {
            const index = this.selectedAddOns.findIndex(item => item.add_on_id === addOnId);
            if(index === -1) {
                this.selectedAddOns.push({
                    add_on_id: addOnId,
                    qty
                });
            }else {
                if(qty === 0) {
                    this.selectedAddOns.splice(index, 1);
                }else {
                    this.selectedAddOns[index].qty = qty;
                }
            }
        },
        /**
         * addBtn on click handler
         */
        addBtnOnClick() {
            if(this.qty + this.sessionOrder.order_items.length > 10 && !sessionStorage.getItem("isShowAskExcelOrderPopup")) {
                window.popups.askExcelOrderPopup.openPopup();
                return;
            }
            this.addOrderItem({
                product_id: this.product_id,
                qty: this.qty,
                wines: this.selectedWines,
                add_ons: this.selectedAddOns
            });

            this.pushToDataLayer();

        },
        pushToDataLayer() {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'addToCart',
                "productId": this.product.id,
                "productCode": this.product.product_code,
                "qty": this.qty,
                "name_zh_hk": this.product.name_zh_hk,
                "name_en": this.product.name_en
            });
        }
    },
    created() {
        axios.get(window.apiEndpoints['product.details'], {
            params: {
                id: this.product_id
            }
        })
            .then(res => {
                const {data: {
                    product,
                    product_wine_groups,
                    wine_groups,
                    add_ons
                }} = res.data;
                this.$data.product = product;
                this.$data.productWineGroups = product_wine_groups;
                this.$data.wineGroups = wine_groups;
                this.$data.addOns = add_ons;

                product_wine_groups.forEach(item => {
                    const wine_group = wine_groups.find(wine_group => wine_group.id === item.wine_group_id);
                    const wine_id = wine_group ? wine_group.wines[0].id : null;
                    this.$data.selectedWines.push({
                        product_wine_group_id: item.id,
                        wine_id
                    })
                });
            })
    }
});